var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-sale-open-page"},[_c('img',{attrs:{"src":require("@/assets/404_images/noSaleCard.png"),"alt":""}}),_c('el-button',{staticClass:"btn",attrs:{"type":"primary"},on:{"click":_vm.logout}},[_vm._v("退出")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }